// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shop_box{padding:10px 20px 20px 30px}.shop_box>div{margin-bottom:20px}.cover-uploader .el-upload{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.cover-uploader .el-upload:hover{border-color:#409eff}", ""]);
// Exports
module.exports = exports;
